import React, { forwardRef } from 'react';

interface TileProps {
  letter: string;
  state: 'empty' | 'G' | 'R';
  onChange?: (value: string) => void;
  onBackspace?: () => void;
  editable?: boolean;
  flip?: boolean; // trigger flip animation
}

export const Tile = forwardRef<HTMLInputElement, TileProps>(
  ({ letter, state, onChange, editable = true, flip = false }, ref) => {
    // DEBUG: Log every render with unique identifier
    const tileId = React.useRef(Math.random().toString(36).substr(2, 9));
    // console.log(`Tile ${tileId.current} rendered - letter: "${letter}", state: "${state}", flip: ${flip}, editable: ${editable}`);
    
    // Colors
    const bgColorMap: Record<string, string> = {
      empty: '#1f2937', // dark gray
      G: '#34d399',     // green
      R: '#f87171',     // red
    };
    
    const borderColor = letter ? '#6b7280' : '#374151';

    return (
      <div
        className="w-9 h-9 relative"
        style={{
          perspective: '600px',
        }}
      >
        <div
          className="relative w-full h-full transition-transform duration-600"
          style={{
            transformStyle: 'preserve-3d',
            transform: flip ? 'rotateX(180deg)' : 'rotateX(0deg)',
          }}
        >
          {/* FRONT FACE - Input */}
          <div
            className="absolute w-full h-full flex items-center justify-center rounded-sm border"
            style={{
              backfaceVisibility: 'hidden',
              borderColor,
              backgroundColor: '#1f2937', // default empty color
            }}
          >
            <input
              type="text"
              value={letter}
              ref={ref}
              readOnly={!editable}
              onChange={(e) => onChange?.(e.target.value.toUpperCase().slice(0, 1))}
              className="w-full h-full text-center text-xl text-white font-bold bg-transparent focus:outline-none focus:ring-0 cursor-default pointer-events-none"
              style={{
                caretColor: 'transparent',
              }}
            />
          </div>

          {/* BACK FACE - Colored result */}
          <div
            className="absolute w-full h-full flex items-center justify-center rounded-sm border text-white text-xl font-bold"
            style={{
              backfaceVisibility: 'hidden',
              transform: 'rotateX(180deg)',
              borderColor,
              backgroundColor: bgColorMap[state] || bgColorMap.empty,
            }}
          >
            {letter}
          </div>
        </div>
      </div>
    );
  }
);

Tile.displayName = 'Tile';